var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApprovals = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M1.2 1.51 8.73 7.8a2 2 0 0 0 2.57 0l7.53-6.28"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 14,
  x: 0.5,
  y: 1,
  stroke: "currentColor",
  rx: 1.55
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgApprovals);
export default ForwardRef;